import React from "react";
import PropTypes from "prop-types";

import { gatherClasses, isFunction } from "../../lib/utils";
import PoweredByDruva from "../poweredByDruva/poweredByDruva";
import "./footerLinks.scss";

const FooterLinks = ({ inSidebar, links }) => {
  return (
    <div
      className={gatherClasses(
        null,
        "oui-global-footer-links",
        inSidebar && "oui-in-sidebar"
      )}
    >
      <PoweredByDruva white={inSidebar} />
      {links.map((link, index) =>
        isFunction(link.renderComponent) ? (
          link.renderComponent(
            link,
            `global-footer-link-${index}-${link.label}`
          )
        ) : (
          <a
            href={link.href}
            target={link.target}
            key={`global-footer-link-${index}-${link.label}`}
          >
            {link.label}
          </a>
        )
      )}
    </div>
  );
};

FooterLinks.propTypes = {
  inSidebar: PropTypes.bool,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      target: PropTypes.oneOf(["_blank", "_self", "_parent", "_top"]),
      label: PropTypes.string.isRequired,
      href: PropTypes.string,
      renderComponent: PropTypes.func
    })
  )
};

FooterLinks.defaultProps = {
  inSidebar: false,
  links: []
};

FooterLinks.displayName = "OrionFooterLinks";

export default FooterLinks;
